import { createContext, FC, PropsWithChildren, useCallback, useState } from 'react';

import { ContextProps } from './TributeWizardContext.types';


export const defaultContext: ContextProps = {
  data: {},
  setData: () => {},
  clearData: () => {},
};

export const TributeWizardContext = createContext(defaultContext);

export const TributeWizardProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  const [data, setData] = useState<ContextProps['data']>(defaultContext.data);
  const setDataField = useCallback((field: string, value: any) => {
    setData((prevData: any) => ({
      ...prevData,
      [field]: value,
    }));
  }, []);

  const clearData = useCallback(() => {
    setData({});
  }, []);

  return (
    <TributeWizardContext.Provider
      value={{
        data,
        setData: setDataField,
        clearData,
      }}
    >
      {children}
    </TributeWizardContext.Provider>
  );
};

export const TributeWizardConsumer = TributeWizardContext.Consumer;
